export default {
  loyalty:
    'Ман шартҳои <a target="_blank" href="{link}">барномаи вафодорӣ</a> шарикони RC Group-ро қабул мекунам',
  posOferta:
    'Ман шартҳои <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">созишнома</a>-и хидмати RC POS-ро қабул мекунам',
  1: "Маълумоти асосӣ",
  2: "Маълумоти шахсӣ",
  3: "Шахси ҳуқуқӣ",
  haveAcc: "Ҳисоб доред?",
  login: "Вуруд",

  mainInfo: {
    title: "Маълумоти асосӣ",
    promocode: "Промокод",
    country: "Кишвар",
    phone: "Рақами телефон",
    checkbox:
      " Ман ризоият медиҳам ба коркарди маълумоти шахсӣ тибқи\n" +
      "<a download href='{link}'>Сиёсати махфият</a>",
    oferta:
      "Ман шартҳои" + " <a download href='{link}'>Офертаро</a> қабул мекунам",
  },

  profileInfo: {
    title: "Маълумоти шахсӣ",
    firstName: "Ном",
    lastName: "Насаб",
    middleName: "Номи падар",
    email: "Почта",
    password: "Парол",
    confPassword: "Такрори парол",
    registerCode: "Рамз аз почта",
    notSendCode: "Рамз наомад?",
    sendAgain: "Бори дигар фиристодан",
  },

  emailCode: {
    title: "Рамзи тасдиқ ба почтаи шумо фиристода шуд",
    subtitle:
      'Агар шумо нома ба "{mail}" нагирифта бошед, ҷузвдони «Спам»-ро санҷед',
    emailCode: "Рамз аз почта",
    sendAgainTime: "Рамзро бори дигар баъд аз фиристодан",
    dontSend: "Рамз наомад?",
    sendAgain: "Бори дигар фиристодан",
  },

  entity: {
    title: "Шахси ҳуқуқӣ",
    subTitle:
      "Лутфан, пеш аз пахш кардани тугмаи «Давом додан», маълумоти воридшударо санҷед",
    entityType: "Навъи шахси ҳуқуқӣ",
    halalCertificate: "Шахси ҳуқуқӣ сертификати Ҳалол дорад",
    fileType: "PNG, JPG, PDF - 1 файл то 10 Мб",
    commercial: "Тиҷоратӣ",
    checkbox: "Шахси ҳуқуқӣ ба фаъолияти соҳибкорӣ машғул аст",
  },

  payment: {
    title: "Ташаккур барои бақайдгирӣ!",
    subtitle:
      "Акнун шумо метавонед ба кабинети шахсии барномаи вафодории RC Group ворид шавед.",
    moderation:
      "Дар айни ҳол шахси ҳуқуқии шумо дар модератсия қарор дорад. Одатан санҷиш аз 24 то 48 соат вақт мегирад",
    examination:
      "Барои гузаштан аз санҷиш, ба шумо лозим аст ҳисобро аз номи шахси ҳуқуқии зикршуда пардохт кунед, онро тавассути тугмаи зер бор карда. Ҳисобро ҳамчунин метавонед дар ҳисоби шахсӣ дар қисмати «Корхонаҳои ман» - «Ҳуҷҷатҳо» бо номи «Пардохти санҷишӣ» пайдо кунед.",

    goToCabinet: "Ба кабинет гузаштан",
    alternativeCheck: {
      button: "Усули алтернативии гузаштани санҷиш",
      description:
        "Ба шумо лозим аст ҳуҷҷати “Анкета-ариза”-ро боргирӣ кунед, имзо гузоред, муҳр занед ва ба почтаи ширкат фиристед.",
    },
  },

  alternativePayment: {
    title: "Агар имкони пардохти ҳисоб набошад",
    signDocAndSendToMail:
      "Барои гузаштани санҷиш, ба шумо лозим аст ҳуҷҷатро имзо кунед, онро тавассути тугмаи зер боргирӣ намоед ва дар ин саҳифа бор кунед ё ба почтаи <b>hello@rc.city</b> фиристед",
    whereIsDoc:
      "Шумо ҳамчунин метавонед ҳуҷҷатро дар ҳисоби шахсӣ дар қисмати «Корхонаҳои ман» — «Ҳуҷҷатҳо» бо номи «Анкета - тасдиқи шахси ҳуқуқӣ» пайдо кунед",
    downloadFileName: "Анкета-ариза",
    useMainCheckWay: "Усули асосии гузаштани санҷишро истифода бурдан",
    paymentInvoice: "Ҳисоби пардохт",
  },
};
